// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"node_modules_pnpm_dompurify_2_4_7_node_modules_dompurify_dist_purify_js":"b2d9a3f15547455e","node_modules_pnpm_canvg_3_0_10_node_modules_canvg_lib_index_es_js":"45f2950b38b9e0f1"}[chunkId] + ".js";
};